import { render } from "./lyDataPanel.vue?vue&type=template&id=d4bca20a&scoped=true"
import script from "./lyDataPanel.vue?vue&type=script&lang=js"
export * from "./lyDataPanel.vue?vue&type=script&lang=js"

import "./lyDataPanel.vue?vue&type=style&index=0&id=d4bca20a&lang=scss"
import "./lyDataPanel.vue?vue&type=style&index=1&id=d4bca20a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4bca20a"]])

export default __exports__